import React from 'react';
import { motion } from 'framer-motion';
import { Tag } from 'lucide-react';

interface BlogCategoriesProps {
  categories: string[];
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
}

export const BlogCategories: React.FC<BlogCategoriesProps> = ({
  categories,
  selectedCategory,
  onSelectCategory
}) => {
  return (
    <div className="flex items-center space-x-4">
      <motion.button
        onClick={() => onSelectCategory(null)}
        className={`px-4 py-2 rounded-lg transition-colors ${
          !selectedCategory 
            ? 'bg-neon-green/20 text-neon-green' 
            : 'bg-white/5 text-gray-400 hover:bg-white/10'
        }`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        All
      </motion.button>
      {categories.map(category => (
        <motion.button
          key={category}
          onClick={() => onSelectCategory(category)}
          className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
            selectedCategory === category
              ? 'bg-neon-green/20 text-neon-green'
              : 'bg-white/5 text-gray-400 hover:bg-white/10'
          }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Tag className="w-4 h-4" />
          <span>{category}</span>
        </motion.button>
      ))}
    </div>
  );
};